import { Component, HostBinding, Input } from '@angular/core'

@Component({
    selector: 'app-section-row',
    template: '<ng-content></ng-content>',
    styleUrls: ['./section-row.component.scss'],
})
export class SectionRowComponent {
    @HostBinding('style.--section-flex-basis.px')
    @Input()
    minSectionWidth = 0
}
